<div class="clear-row wide title-padding">
  <span
    *ngIf="!isDelete"
    class="lx-title">
    Review Cohort {{ cohortChanges?.name }}
  </span>
  <span
    *ngIf="isDelete"
    class="lx-title deletion">
    Delete Cohort {{ cohortChanges?.name }}
  </span>
  <i
    class="lx-icon lx-close-x"
    style="cursor: pointer"
    (click)="close()"></i>
</div>

<div *ngIf="isLoading; else doneLoading">
  <div
    class="spinner-border text-primary"
    role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<ng-template #doneLoading>
  <dcc-cohort-status-indicator
    class="extra-space"
    [status]="cohort.status"></dcc-cohort-status-indicator>

  <div class="extra-space">
    <p class="lx-label">REQUEST CREATOR</p>
    <span class="clear-row lx-body">
      <span>{{ cohortChanges?.requestCreator }}</span>
      <span>{{ cohortChanges?.timestamp | date: 'MMMM d, y, h:mm:ss a' }}</span>
    </span>
  </div>

  <div
    *ngIf="hasStatusChange"
    class="extra-space">
    <p class="lx-label">STATUS CHANGE</p>
    <div class="approval__shaded__row lx-body">
      <dcc-cohort-status-indicator
        [status]="
          cohortChanges?.statusChange.currentStatus
        "></dcc-cohort-status-indicator>
      <div>-></div>
      <dcc-cohort-status-indicator
        [status]="
          cohortChanges?.statusChange.proposedStatus
        "></dcc-cohort-status-indicator>
    </div>
  </div>

  <div class="extra-space">
    <p class="lx-label">Description</p>
    <label class="lx-body">{{ cohortChanges?.cohortDescription }}</label>
  </div>

  <div class="extra-space">
    <dcc-cohort-entities-details
      *ngIf="entitiesRemoved.length || legacyEntitiesRemoved.length"
      header="Entities"
      headerColor="#F94E4E"
      padding="20px"
      subHeader="- Removed"
      [entities]="entitiesRemoved"
      [legacyEntities]="legacyEntitiesRemoved"></dcc-cohort-entities-details>
    <dcc-cohort-entities-details
      *ngIf="entitiesAdded.length || legacyEntitiesAdded.length"
      headerColor="#00B884"
      subHeader="+ Added"
      [entities]="entitiesAdded"
      [legacyEntities]="legacyEntitiesAdded"></dcc-cohort-entities-details>
  </div>

  <div class="extra-space">
    <div
      *ngIf="isDelete"
      class="approval__shaded__column lx-body">
      <span class="extra-space lx-label">DELETE COHORT</span>
      <span class="extra-space">{{ cohortChanges?.name }}</span>
    </div>
  </div>

  <div class="extra-space">
    <div
      *renderingPermissionDirective="['ModuleUpdateAdmin']"
      class="approval__shaded__column lx-body">
      <label
        class="approval__shaded__row small-gap"
        [ngStyle]="{
          'font-weight':
            currentApprovalOption === 'Approved' ? '700' : 'normal',
        }">
        <input
          name="approvalOption"
          type="radio"
          value="Approved"
          [checked]="currentApprovalOption === 'Approved'"
          (change)="onApprovalOptionChange($event)" />
        Approve
      </label>
      <label
        class="approval__shaded__row small-gap"
        [ngStyle]="{
          'font-weight':
            currentApprovalOption === 'Rejected' ? '700' : 'normal',
        }">
        <input
          name="approvalOption"
          type="radio"
          value="Rejected"
          [checked]="currentApprovalOption === 'Rejected'"
          (change)="onApprovalOptionChange($event)" />
        Reject
      </label>
    </div>
  </div>

  <div class="clear-row lx-body">
    <button
      class="lx-btn lx-btn-secondary approval-btn"
      (click)="close()">
      Close
    </button>
    <button
      *renderingPermissionDirective="['ModuleUpdateAdmin']"
      class="lx-btn lx-btn-primary approval-btn"
      (click)="onSave()">
      Save
    </button>
  </div>
</ng-template>
